import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, shareReplay, throwError } from 'rxjs';
import { environment } from '../../../../../../../../../environments/environment';
import { AuthService } from '../../../../../../../../core/service/auth.service';
import { IntentPaymentResponse, SavePaymentRequest } from '../interfaces/add-new-card.interface';

@Injectable({
  providedIn: 'root'
})
export class AddNewCardService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }


 get headers(): HttpHeaders {
    const token = this.authService.getToken();

    return new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  }


  /**
   * Guarda una nueva tarjeta con Stripe
   * @param cardData Datos de la tarjeta a guardar
   * @returns Observable con la respuesta del servidor
   */
  saveCard(payment_method_id: {payment_method_id: string}): Observable<SavePaymentRequest> {

    try {
      return this.http.post<SavePaymentRequest>(
        `${environment.apiUrl}/payment/method`,
        payment_method_id,
        { headers: this.headers }
      ).pipe(
          shareReplay(1),
        catchError((error) => {
          return throwError(() => error);
        })
      );
    } catch (error) {
      return throwError(() => error);
    }
  }

  /**
   * Crea un Intent de Pago con Stripe
   * @returns Observable con la respuesta del servidor
   */
  intentCard(): Observable<IntentPaymentResponse>{
    return this.http.post<IntentPaymentResponse>(
      `${environment.apiUrl}/payment/setup-intent`,
      {},
      { headers: this.headers }
    );
  }




}
